var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 6.85714H19.7143V4.28571H17.1428V2.57143H21.4286V6.85714ZM21.4286 21.4286V17.1429H19.7143V19.7143H17.1428V21.4286H21.4286ZM2.57141 21.4286H6.85713V19.7143H4.2857V17.1429H2.57141V21.4286ZM2.57141 2.57143V6.85714H4.2857V4.28571H6.85713V2.57143L2.57141 2.57143Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13V18H6V13H11ZM14.5714 16.2857V18H12.8571V16.2857H14.5714ZM18 16.2857V18H16.2857V16.2857H18ZM16.2857 14.5714V16.2857H14.5714V14.5714H16.2857ZM14.5714 12.8571V14.5714H12.8571V12.8571H14.5714ZM18 12.8571V14.5714H16.2857V12.8571H18ZM11 6V11H6V6H11ZM18 6V11H13V6H18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.e53f8ca8.svg";
export { ForwardRef as ReactComponent };